// extracted by mini-css-extract-plugin
module.exports = {"buttons":"DigitalCards_buttons___190o","walletImageContainer":"DigitalCards_walletImageContainer__lh1UY","addToGPayContainer":"DigitalCards_addToGPayContainer__dPQu7"};